import { useState, useEffect, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { graphicDataColor1 } from "../../../../config/constants";
// Components
import Graphic from "../../../graphic";
import GraphicContainer from "../../../GraphicContainer";

const VolumePlot = forwardRef(({ metrics }, ref) => {
  const [positions, setPositions] = useState([]);
  const [volumeValues, setVolumeValues] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let positions = [];
    let volume = [];

    metrics.forEach((metric, i) => {
      positions.push(i + 1);

      volume.push(metric.hasOwnProperty("volume") ? metric.volume : NaN);
    });

    setPositions(positions);
    setVolumeValues(volume);

    return () => {
      setPositions([]);
      setVolumeValues([]);
    };
  }, [metrics]);

  const volumeData = {
    labels: positions,
    datasets: [
      {
        label: t("reports_volume"),
        data: volumeValues,
        backgroundColor: [graphicDataColor1],
        borderColor: [graphicDataColor1],
      },
    ],
  };

  return (
    <GraphicContainer ref={ref}>
      <Graphic
        Title={t("reports_volume")}
        Type={Line}
        data={volumeData}
        axisY={t("reports_volume")}
        axisX={t("sessions")}
        graphicDescription={t("graphics_volumeDescription_App")}
        isBeta
      />
    </GraphicContainer>
  );
});

export default VolumePlot;
